export default "__VITE_ASSET__f5cda954__"